import React from 'react';
import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd';
import { RangePickerProps as AntdRangePickerProps } from 'antd/es/date-picker';
import classNames from 'classnames';
import moment from 'moment';
import "moment/locale/ko";
import locale from "antd/lib/locale/ko_KR";

const SearchRangePicker = ({ className, ...rest }: AntdRangePickerProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const { RangePicker }: any = AntdDatePicker;
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <ConfigProvider locale={locale}>
      <RangePicker
        ranges={{
          '지난 1일': [moment().subtract('1', 'd'), moment().subtract('0', 'd')],
          '지난 1주': [moment().subtract('7', 'd'), moment().subtract('0', 'd')],
          '지난 2주': [moment().subtract('14', 'd'), moment().subtract('0', 'd')],
          '지난 1개월': [moment().subtract('1', 'M'), moment().subtract('0', 'd')],
          '지난 3개월': [moment().subtract('3', 'M'), moment().subtract('0', 'd')],
          '지난 6개월': [moment().subtract('6', 'M'), moment().subtract('0', 'd')],
          '지난 1년': [moment().subtract('1', 'y'), moment().subtract('0', 'd')],
        }}
        className={classNames('range-picker', className)}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default SearchRangePicker;
